import { render, staticRenderFns } from "./MetaLeadsContactListSwitcher.vue?vue&type=template&id=4a1db656"
import script from "./MetaLeadsContactListSwitcher.vue?vue&type=script&lang=js"
export * from "./MetaLeadsContactListSwitcher.vue?vue&type=script&lang=js"
import style0 from "./MetaLeadsContactListSwitcher.vue?vue&type=style&index=0&id=4a1db656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports